import { useNavigate } from "react-router";
import { MainPadding } from "../../../../styles/Main.styles";
import { useState } from "react";
import TableFC, {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../../components/table/Table";
import { useGetPaymentMethods } from "../../api/invoice/paymentMethod/resolver";
import TableHeader from "../../../../components/table/TableHeader";

export default function MainPaymentMethod() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { data: dataRawPaymentMethod, isLoading: loadingFetchPaymentMethod } =
    useGetPaymentMethods({ keyword, page, perPage });
  const dataPaymentMethod = dataRawPaymentMethod?.data.data.data;
  const header: TableHeadProps[] = [{ title: "No" }, { title: "Nama" }];
  const body: TableFCBodyProps[] = [{ key: "payment_method_name" }];

  return (
    <MainPadding>
      <TableHeader
        addButton
        filterLabel="Search Metode Pembayaran"
        searchBar
        onSearch={(e) => setKeyword(e)}
        onClickAdd={() => navigate("/invoice/payment-method/creation")}
      />
      <TableFC
        loading={loadingFetchPaymentMethod}
        data={dataPaymentMethod}
        body={body}
        showIndex
        totalRows={dataRawPaymentMethod?.data.data.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        head={header}
        onPageChange={(e) => setPage(e)}
        onCellClick={(e) =>
          navigate(`/invoice/payment-method/creation/${e.id}`)
        }
      />
    </MainPadding>
  );
}
